import React from 'react';
import { Shield, Download, Lock, CheckCircle } from 'lucide-react';
import { FadeIn } from './FadeIn';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferSection() {
  return <section id="comprar" className="py-24 md:py-32 bg-white relative overflow-hidden" data-id="element-168">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl" data-id="element-169">
        <div className="bg-navy rounded-3xl md:rounded-[3rem] p-8 md:p-16 relative overflow-hidden shadow-2xl" data-id="element-170">
          {/* Decorative elements */}
          <div className="absolute top-0 right-0 w-full h-full overflow-hidden opacity-20 pointer-events-none" data-id="element-171">
            <div className="absolute -top-[50%] -right-[20%] w-[80%] h-[150%] rounded-full bg-teal blur-3xl" data-id="element-172"></div>
            <div className="absolute -bottom-[50%] -left-[20%] w-[80%] h-[150%] rounded-full bg-amber blur-3xl" data-id="element-173"></div>
          </div>

          <div className="relative z-10 grid md:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-174">
            <FadeIn data-id="element-175">
              <div className="text-white" data-id="element-176">
                <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-amber/20 text-amber font-bold mb-8 border border-amber/30" data-id="element-177">
                  <Shield size={18} data-id="element-178" />
                  <span data-id="element-179">Oferta Especial</span>
                </div>

                <h2 className="text-4xl md:text-5xl font-serif font-bold mb-6 leading-tight" data-id="element-180">
                  Protege el futuro emocional de tu hijo hoy mismo.
                </h2>

                <p className="text-xl text-gray-300 mb-8 leading-relaxed" data-id="element-181">
                  Por el precio de una cena, obtienes el protocolo completo de
                  intervención que el colegio no te dará.
                </p>

                <div id="precio" className="bg-white/10 border border-white/20 rounded-2xl p-6 mb-8 backdrop-blur-sm" data-id="element-182">
                  <p className="text-gray-400 text-sm uppercase tracking-wider font-bold mb-2" data-id="element-183">
                    Inversión única
                  </p>
                  <div className="flex items-baseline gap-3 mb-2" data-id="element-184">
                    <span className="text-2xl md:text-3xl font-bold text-gray-500 line-through" data-id="element-185">
                      $27.00
                    </span>
                    <span className="text-5xl md:text-6xl font-bold text-amber" data-id="element-186">
                      $7.39
                    </span>
                    <span className="text-xl text-gray-300" data-id="element-187">USD</span>
                  </div>
                  <p className="text-teal-light text-sm font-semibold uppercase tracking-wide" data-id="element-188">
                    🔥 ¡Descuento del 73% por tiempo limitado!
                  </p>
                </div>

                <ul className="space-y-4 mb-10" data-id="element-189">
                  {['Guía paso a paso en PDF', 'Guiones del Método N.E.A.', 'Plantillas Legales'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-200" data-id="element-190">
                      <CheckCircle size={20} className="text-teal-light" data-id="element-191" />
                      {item}
                    </li>)}
                </ul>

                <a href="https://www.auriadigitalstore.com/cart/52166608257317:1" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="w-full py-5 bg-amber hover:bg-amber-light text-navy font-bold rounded-xl transition-all duration-300 transform hover:-translate-y-1 shadow-[0_10px_40px_-10px_rgba(212,168,67,0.6)] text-xl flex items-center justify-center gap-3" data-id="element-192">
                  <Download size={24} data-id="element-193" />
                  ACCEDER AL ESCUDO AHORA
                </a>

                <div className="mt-6 flex items-center justify-center gap-2 text-gray-400 text-sm" data-id="element-194">
                  <Lock size={16} data-id="element-195" />
                  <span data-id="element-196">Pago 100% seguro. Descarga inmediata en PDF.</span>
                </div>
              </div>
            </FadeIn>

            <FadeIn direction="left" delay={0.2} data-id="element-197">
              <div className="relative flex justify-center" data-id="element-198">
                <div className="absolute inset-0 bg-amber rounded-full transform scale-90 opacity-20 blur-2xl" data-id="element-199"></div>
                <img src="https://cdn.magicpatterns.com/uploads/gbPfC8fCK5mNeKSZVwEg93/ESCUDO_DE_CONFIANZA.png" alt="Ebook Escudo de Confianza" className="relative z-10 w-full max-w-md rounded-2xl shadow-2xl transform md:-rotate-3 transition-transform hover:rotate-0 duration-500" data-id="element-200" />
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}